
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-category-view',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop() readonly blockId: number;
  @Prop() readonly catalogData: object;
  @Prop() readonly dataSource: string;
  @Prop({default: () => []}) private wishlistItems: Array<object>;
  @Prop() readonly attributes: object;
  @Prop({default: () => false}) readonly urlFiltersFeatureEnabled: boolean;

  private created(): void {
    this.$store.commit(`${this.dataSource}/SET_BLOCK_ID`, this.blockId);
    this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, this.catalogData);
    this.$store.commit(`${this.dataSource}/SET_DEFAULT_ATTRIBUTES`, this.attributes);
    this.$store.commit(`${this.dataSource}/SET_URL_FILTERS_FEATURE_ENABLED`, this.urlFiltersFeatureEnabled);
  }
}
